import React, { useContext } from "react";
import { TwoColumn } from "../../core/layouts";
import DensoLogo from "../../components/DensoLogo/DensoLogo";
import variables from "../../themes/base/styles/variables";
import QuickLinksContainer from "../QuickLinksContainer/QuickLinksContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../globalContext/auth/authProvider";

const QuickLinksContainerStyle = {
  style: (isDnsd) => ({
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: !isDnsd && variables.gapMedium2,
  }),
  logo: {
    width: variables.navbarLogoWidth,
    height: variables.navbarLogoHeight,
    cursor: "pointer",
  },
};

export default function QuickLinksLogoContainer() {
  const navigate = useNavigate();
  const [authState] = useContext(AuthContext);

  const { pathname } = useLocation();

  return (
    <TwoColumn
      style={QuickLinksContainerStyle.style(!authState?.currentRole?.id)}
      leftSection={
        authState?.currentRole?.id &&
        !pathname.includes("access-denied") && <QuickLinksContainer />
      }
      rightSection={
        <DensoLogo
          style={QuickLinksContainerStyle.logo}
          onClick={() => authState?.currentRole?.id && navigate("/")}
        />
      }
    />
  );
}
